export { default } from "./useEventCallback.mjs";